export default {
  data: () => ({
    navbar: {
      about: { en: "ABOUT US", fr: "A PROPOS" },
      what: { en: "THE WHAT", fr: "LE QUOI" },
      how: { en: "THE HOW", fr: "LE COMMENT" },
      contact: { en: "CONTACT US", fr: "CONTACTEZ-NOUS" }
    },
    app_details: {

      name: { en: "Human Time Initiatives", fr: "Human Time Initiatives" },
      // motto: { en: "Weaving Technology into Business Models", fr: "Intégrer la technologie dans les modèles d'entreprise" }
      motto: {
        en: 
          "Follow and track daily undertakings! Though large portions of our time is spent working, we devote significant moments doing other important things, like care-giving, youth coaching and community projects. HTI’s aims to highlight actual time devoted to these actions!",
        fr: 
          "Suivez et repérez vos activités quotidiennes! Même si nous consacrons une grande partie de notre temps au travail, nous en consacrons également une part importante à d’autres activités essentielles, telles que l’aide aux personnes dépendantes, l’encadrement des jeunes et les projets communautaires. HTI a pour objectif de mettre en lumière le temps réellement consacré à ces activités !"
      },
      slogan: {
        en:
          "Are you a DONOR, NGO or ESG program initiator seeking to impact meaningfully? Then, work with us.",
        fr:
          "Êtes-vous un donateur, une ONG ou un initiateur de programme ESG qui cherche à avoir un impact significatif ? Alors, travaillez avec nous."
      }
    },
    headers: {
      about: { en: "About Our Association", fr: "À propos de notre association" },
      what: { en: "WHAT WE DO", fr: "CE QU’ON FAIT" },
      how: { en: "HOW WE DO IT", fr: "COMMENT LE FAIT-ON" },
      add_info: { en: "OUR WORK & PROJECT", fr: "NOTRE TRAVAIL & PROJETS" },
      contact: { en: "CONTACT US", fr: "CONTACTEZ-NOUS" },
      management: {en: "Management", fr: "Gestion"},
      advisory_board: {en: "Advisory Board", fr: "Conseil Consultatif"},
      development_team: {en: "Development Team", fr: "Équipe de Développement"}
    },
    aboutContent: {
      en:
        "We are ‘professionals’ concerned and passionate about the fact that society is not paying attention to the aspects of life concerning tiny things we overlook or consider irrelevant that actually lay the building blocks for sustainable societies. We are enthusiast, with the unique art of incorporating sustainable business practises with societal needs. A 360° understanding of both Society & Business motivates us to contribute what we can to help build the basis for the much-required sustainability currently becoming an essential aspect of our collective consciousness.",
      fr:
        "Nous sommes des « professionnels » préoccupés et passionnés par le fait que la société ne prête pas attention aux aspects de la vie concernant des choses minuscules que nous négligeons ou que nous considérons comme non pertinentes, alors qu'elles constituent en fait les fondements de sociétés durables. Nous sommes des enthousiastes, avec l'art unique d'incorporer des pratiques commerciales durables aux besoins de la société. Une compréhension à 360° de la société et de l'entreprise nous motive à apporter notre contribution pour aider à construire les bases de la durabilité tant recherchée, qui devient actuellement un aspect essentiel de notre conscience collective."
    },
    aboutContentPoints: {
      en:
        "Our professional backgrounds are associated with renowned Brands in the areas of Marketing, Engineering and Design.",
      fr:
        "Nos expériences professionnelles sont associées à des marques renommées dans les domaines du marketing, de l'ingénierie et du design."
    },
    teamTitles: {
      founder: {en: "Founding Partner", fr: "Associé Fondateur"},
      software_engineer: {en: "Software Engineer", fr: "Ingénieur logiciel"},
      UIUX: {en: "UI/UX Engineer", fr: "Ingénieur UI/UX"},
      development_specialist: {en: "Development Specialist", fr: "Spécialiste développement"},
      financial_specialist: {en: "Financial Specialist", fr: "Spécialiste financier"},
      president: {en: "President", fr: "Président"},
      secretary: {en: "Secretary", fr: "Secrétaire"},
      treasury: {en: "Treasury + Technology", fr: "Trésorerie + Technologie"},
      consultant: {en: "Consultant", fr: "Consultant"},
      communication: {en: "Communication", fr: "Communication"},
      member: {en: "Member", fr: "Membre"},
    },
    theHow: [
      {
        title: { en: "Optimal Usage of Time", fr: "Gestion Optimale" },
        text: {
          en:
            "Providing innovative digital tools to assist teams on assignment to optimize their time usage in the community and society in general",
          fr:
            "Fournir des outils numériques innovants pour aider les équipes en mission à optimiser leur emploi du temps au sein de la communauté et de la société en général."
        },
        reveal: false
      },
      {
        title: { en: "Project Evaluation", fr: "Evaluation des <br/>Projets" },
        text: {
          en:
            "Assisting Small Teams, Associations & NGOs in monitoring and evaluating project timelines to guarantee the quality, effectiveness and outcome of actions by using appropriate analytical tools and indicators.",
          fr:
            "Assister les petites équipes, les associations et les ONG dans le suivi et l'évaluation des délais des projets afin de garantir la qualité, l'efficacité et les aboutissements des actions à l'aide d'outils analytiques et d'indicateurs appropriés."
        },
        reveal: false
      },
      {
        title: { en: "Governance Support", fr: "Gouvernance" },
        text: {
          en:
            "Providing resources, training and tools to improve the governance of Small Teams, Associations & NGOs. Promoting transparent management and strengthening the decision-making capacities of Project Managers, Sponsors and Donors",
          fr:
            "Fournir des ressources, des formations et des outils pour améliorer la gouvernance des petites équipes, des associations et des ONG. Promouvoir une gestion transparente et renforcer les capacités de prise de décision des chefs de projet, des sponsors et des mécènes."
        },
        reveal: false
      }
    ],
    theWhat: [
      {
        title: { en: "Our Vision", fr: "Notre vision" },
        text: {
          en:
            "HTI’s vision is to offer ‘general purpose, easy to use’ digital tools that everyone, regardless of occupation can use to measure time put into what can be termed as ‘under the radar activities, in other words activities most may regard as not being essential’",
          fr:
            `La vision de HTI est d'offrir des outils numériques « d'usage général et faciles à employer “ que chacun, quelle que soit sa profession, peut utiliser pour mesurer le temps consacré à ce que l'on peut appeler les ” activités sous le radar », en d'autres termes les activités que la plupart considèrent comme n'étant pas essentielles`
        },
        reveal: false
      },
      {
        title: { en: "Prospects", fr: "Perspectives" },
        text: {
          en:
            "The prospect of actually having basic numerical tools help us quantify time put into humane actions should assist us appreciate the monetary value we contribute indirectly to society.",
          fr:
            "La perspective de disposer d'outils numériques de base nous aidant à quantifier le temps consacré à des actions humaines devrait nous aider à apprécier la valeur monétaire que nous apportons indirectement à la société."
        },
        reveal: false
      },
      {
        title: { en: "The Tech.", fr: "La Tech" },
        text: {
          en:
            "With your objectives deciphered, regardless of whether you are with group of people or an associative entity, by plugging into the primary systems we have created you or your organization will have the foundation on which you can observe the time spent on actions.",
          fr:
            "Une fois vos objectifs décryptés, que vous soyez un groupe de personnes ou une entité associative, en vous connectant aux systèmes primaires que nous avons créés, vous ou votre organisation disposerez d'une base sur laquelle vous pourrez observer le temps consacré aux actions."
        },
        reveal: false
      }
    ],
    addInfo: [
      {
        title: { en: "Thank you for<br/>Contributing!", fr: "Merci pour votre<br/>participation!" },
        text: {
          en:
            "Click Here !",
          fr:
            "Cliquez Ici !"
        },
        reveal: true
      },
      {
        title: { en: "Watch the Video", fr: "Voir la Vidéo" },
        link: 'https://www.youtube.com/embed/S4XwXHI46XM',
        reveal: false
      },
      {
        title: { en: "Our Time Project!", fr: "Notre Projet Temporel!" },
        text: {
          en:
            "The Project you are supporting, thank you!",
          fr:
            "Le projet que vous soutenez, merci !"
        },
        reveal: false
      }
    ],
    stats: [
      {en: "", fr: ""}, 
      {en: "WITH PEOPLE, IMPACT LASTS...", fr: "AVEC LES PERSONNES, L'IMPACT EST DURABLE..."}
      // ["7", { en: "Companies & Projects", fr: "Entreprises & projets" }],
      // ["10+", { en: "Years of Experience", fr: "Total Années d'Expérience" }],
      // ["8", { en: "Engineers & Advisors", fr: "Ingénieurs & Conseillers" }],
      // [
      //   "20+",
      //   { en: "Technologies Implemented", fr: "Technologies Mis en Place" }
      // ]
    ],
    projects: [
      {
        src: require("../assets/projects/time Oo samples-28(1).svg"),
        // color: "#3E5188",
        // dark: true,
        color: "white",
        dark: false,
        reveal: false,
        title: { en: "TIMEOOH", fr: "TIMEOOH" },
        subtitle: { en: "Time to Impact", fr: "Temps D'Impact." },
        description: {
          en:
            "With Timeooh, you and your organisation and those who collaborate and work within its business eco-system have the optimal digital tool to clock in workers from wherever they operate around the world.",
          fr:
            "Avec Timeooh, vous et votre organisation, ainsi que ceux qui collaborent et travaillent au sein de son écosystème, disposez d'un outil numérique optimal pour pointer les travailleurs, où qu'ils se trouvent dans le monde."
        },
        contribution: {
          en:
            "The entire platform, from the Website, to the Android and IOS (in development) applications, were designed and developed by the Tec-linker team.",
          fr:
            "L'ensemble de la plateforme, du site web aux applications Android et IOS (en cours de développement), a été conçu et développé par l'équipe de Tec-linker."
        },
        link: "https://www.mewoha.com/"
      }
      // {
      //   src: require("../assets/logo.png"),
      //   color: "white",
      //   dark: false,
      //   title: {en: "TECLINKER",fr: "TECLINKER"},
      //   subtitle: {en: "Weaving digital technologies.",fr: "Tisser les technologies numériques."},
      //   description: {
      //     en: "Wouldn’t you say we live in tricky times? For those running Start-Ups & Small Businesses, the writing is on the wall. To SURVIVE, EXIST and PROSPER, we can all agree that, AGILITY, FLEXIBILTY and CREATIVITY are now the ‘imperatives’ of the times. ‘Let Tec-Linker weave Digital Technology or assist you in weaving Digital Technologies into your operations so these ‘prerequisites’ become the ‘DNA‘ of your operations.’",
      //     fr: "Ne diriez-vous pas que nous vivons une époque complexe? Pour ceux qui gèrent des start-ups ou des petites entreprises, l'écriture est sur le mur. Pour SURVIVRE, EXISTER et PROSPER, nous pouvons tous convenir que, l'AGILITÉ, la FLEXIBILITÉ et la CRÉATIVITÉ sont désormais les 'impératifs' de l’époque. 'Laissez Tec-Linker tisser la technologie numérique ou vous aider à intégrer les technologies numériques dans vos activités afin que ces 'conditions préalables' deviennent l''ADN' de vos activités'."
      // },
      //   link: "https://www.teclinker.com/"
      // },
      // {
      //   src: require("../assets/projects/ota.svg"),
      //   color: "teal",
      //   dark: true,
      //   reveal: false,
      //   title: {en: "OVERTHINK ACADEMY",fr: "OVERTHINK ACADEMY"},
      //   subtitle: {en: "Millin dollar advice without the million dollar price!",fr: "Un conseil à un million de dollars sans le prix d'un million de dollars!"},
      //   description: {
      //     en: "OverThink Acdemy Is Creating A Global Learning Experience That Delivers Training in Business, Wellness, And Life. Get access to a growing vault of courses, exclusive events, and international adventures.",
      //     fr: "OverThink Academy crée une expérience d'apprentissage globale qui offre une formation dans le domaine des affaires, du bien-être et de la vie. Accédez à une voûte croissante de cours, d'événements exclusifs et d'aventures internationales."
      //   },
      //   contribution: {
      //     en: "The Tec-linker team handles the development and functionality of this project.",
      //     fr: "L'équipe Tec-linker s'occupe du développement et de la fonctionnalité de ce projet."
      //   },
      //   link: "https://overthinkacademy.com/"
      // },
      // {
      //   src: require("../assets/projects/fig_logo.png"),
      //   color: "blue-grey lighten-2",
      //   dark: true,
      //   reveal: false,
      //   title: {en: "FIG BOOKNG SOFTWARE",fr: "FIG BOOKING SOFTWARE"},
      //   subtitle: {en: "Software for managing and growing your service business",fr: "Logiciel pour gérer et développer votre activité de services"},
      //   description: {
      //     en: "Fig makes the process of managing your cleaning company easy. Between our easy-to-use software and endless features – you’re in great hands, allowing you to focus properly on the service you provide to your customers.",
      //     fr: "Fig rend le processus de gestion de votre entreprise de nettoyage facile. Entre notre logiciel facile à utiliser et nos fonctionnalités infinies, vous êtes entre de bonnes mains, ce qui vous permet de vous concentrer correctement sur le service que vous fournissez à vos clients."
      //   },
      //   contribution: {
      //     en: "The Tec-linker team handles and maintains the development, operation and feature growth of the platform.",
      //     fr: "L'équipe de Tec-linker gère et maintient le développement, l'exploitation et la croissance des fonctionnalités de la plateforme."
      //   },
      //   link: "https://bookwithfig.com/"
      // },
      // {
      //   src: require("../assets/projects/joluud.svg"),
      //   // color: "#8E7144",
      //   // dark: true,
      //   color: "white",
      //   dark: false,
      //   reveal: false,
      //   title: {en: "JOLUUD",fr: "JOLUUD"},
      //   subtitle: {en: "Manage request from your facilities",fr: "Gérer la demande à partir de vos installations"},
      //   description: {
      //     en: "The Joluud web and mobile platform improves communication with facility occupants and collaboration with your maintenance team.",
      //     fr: "La pla teforme web et mobile de Joluud améliore la communication avec les occupants des installations et la collaboration avec votre équipe de maintenance."
      //   },
      //   contribution: {
      //     en: "Tec-linker provided support to UI update and improvements on this website.",
      //     fr: "Tec-linker a apporté son soutien à la mise à jour et à l'amélioration de l'interface utilisateur de ce site web."
      //   },
      //   link: "https://www.joluud.com/"
      // },
    ],
    contactHeader: {
      firstname: { en: "First name", fr: "Prénom" },
      lastname: { en: "last name", fr: "Nom de famille" },
      email: { en: "Email", fr: "Courriel" },
      subject: { en: "Subject", fr: "Sujet" },
      message: { en: "Enter a message", fr: "Entrez un message" },
      text: {
        en:
          "Please do not hesitate to contact us if need be, most importantly we welcome all suggestions that can help us better serve you.",
        fr:
          "N'hésitez pas à nous contacter si besoin est, et surtout, toutes les suggestions qui peuvent nous aider à mieux vous servir sont les bienvenues."
      }
    },
    subjects: [
      { en: "Inquiries", fr: "Demandes de renseignements" },
      { en: "Make a Donation", fr: "Faire un don" },
      // {
      //   en: "Jobs (Engineering & Design)",
      //   fr: "Emplois (ingénierie et design)"
      // }
    ],
    misc: {
      copyright: { en: "copyright", fr: "copyright" },
      more: { en: "More", fr: "Plus" },
      readMore: { en: "Read more...", fr: "en savoir plus..." },
      learnMore: { en: "Learn more...", fr: "en savoir plus..." },
      theTeam: { en: "THE TEAM", fr: "L'ÉQUIPE" },
      viewSite: { en: "Website", fr: "Site web" },
      reachUs: { en: "Also reach us on:", fr: "Contactez-nous aussi sur:" },
      submit: { en: "Submit", fr: "Envoyer" },
      thanks: {
        en: "Thank for reaching out",
        fr: "Merci de nous avoir contactés"
      },
      close: { en: "Close", fr: "Fermer" },
      description: { en: "Description", fr: "Description" },
      contribution: { en: "Contribution", fr: "Contribution" }
    },
    status: {
      title: { en: "STATUS", fr: "STATUT" },
      back: { en: "Back", fr: "Retour" },
    }
  })
};
